module.exports = __webpack_public_path__ + "img/1315.80ee93ff.jpg";